import { inject, Injectable } from '@angular/core';
import { AuthService } from "@auth0/auth0-angular";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { MICRO_SERVICES } from "./api.service";
import { SessionService } from "../../services/session/session.service";
import { filter, switchMap } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TrackerService {
  
  private readonly authService = inject(AuthService);
  private readonly http = inject(HttpClient);
  private readonly sessionService = inject(SessionService);
  
  /**
   * À appeler au démarrage de l'application (ex. via APP_INITIALIZER).
   *
   * Traite l'objet `appState` renvoyé après la redirection suite à un login avec Auth0 (`loginWithRedirect`).
   * L'objectif est de mettre à jour la statistique `last_login` dans HubSpot via MS-USER **uniquement si cette action suit une authentification réelle**.
   *
   * Pour cela, on se base sur la propriété `justLoggedIn` transmise dans le `appState` lors du login.
   */
  public trackLoginSuccess(): void {
    this.authService.appState$
    .pipe(
      filter(appState => appState?.justLoggedIn), // ne passe que si justLoggedIn
      switchMap(() => this.sessionService.getSignedInUser()), // on instance le self de sessionService pour récupérer l'id'
      switchMap(() => this.http.post<void>(
        `${environment.api_base_urls[MICRO_SERVICES.MS_USERS]}v2/users/${this.sessionService.self.id}/post-sign-in`,
        {}
      )) // on signale de login
    ).subscribe({
      next: () => console.debug('Login success tracked'),
      error: (err) => console.error(err)
    });
  }
}
